import React, { Component } from 'react';
import offerIcon from './../../../../assets/img/offer_icon.png';
import trolley from './../../../../assets/img/trolley.png';
import cam from './../../../../assets/img/cam.png'

const numfor = new Intl.NumberFormat('en-IN', {
	style: 'currency',
	currency: 'INR',
	minimumFractionDigits: 0
});

export default class ListingProduct extends Component {
	constructor(props) {
		super(props);
		this.state = {
		}
	}

	onClick = (product) => {
		if (this.props.onClick) {
			this.props.onClick(product);
		}
	}

	onClickAddQty = (receivedQuantity) => {
		const { product, palletId } = this.props;
		if (product && product.productInfoResponse && product.listingDetailsResponse) {
			let x = product.productInfoResponse, y = product.listingDetailsResponse;
			this.props.triggerEvent('ON_SELECT_ADD_MORE_QTY', { jpin: x.jpin, product_name: x.title, listing_id: y.listingDetails.listingId });
		}

		let product2 = this.props.product2;
		this.props.history.push({
			pathname: '/Inwarding/Invoice/AddMoreQuantity',
			state: {
				product: product2,
				griProduct: product,
				receivedQuantity: receivedQuantity,
				palletId: palletId
			}
		});
	}

	render() {
		const { product, showQty, onClick, mrp, receivedQuantity, mOffer } = this.props;
		return (
			<div className="top-ten" style={product.new ? { border: '2px solid yellow' } : {}}>
				<div className={"added-prdct-wrpr " + (onClick ? 'up-sh-box' : '')} onClick={() => { this.onClick(product) }}>
					<div className="row">
						<div className="col-xs-3" style={{ paddingRight: '7px', textAlign: 'center' }}>
							{(product.productInfoResponse.imageUrls[0]) ?
								<img src={product.productInfoResponse.imageUrls[0].thumbnail} style={{ maxWidth: '100%', maxHeight: '80px' }} alt="product" />
								:
								<img src={cam} style={{ maxWidth: '100%', maxHeight: '80px' }} alt="product" />
							}
						</div>
						<div className="col-xs-9" style={{ textAlign: 'initial' }}>
							<div className="v-imp-txt">{product.productInfoResponse.title}</div>
							<div style={{ display: 'flex' }}>
								<div className="pr-mrp top-ten">MRP {numfor.format(mrp ? mrp : product.mrp)}</div>
								{(product.freebie) ?
									<div className="greenBac">Freebie</div>
									:
									null
								}
							</div>

							{mOffer && !product.freebie ?
								<div style={{ padding: '10px 0' }}>
									<img src={offerIcon} alt="offer" /> {mOffer.title}
								</div>
								:
								null
							}

							{(showQty) ?
								<div className="v-imp-txt top-ten" >
									<hr />
									<div style={{ display: 'flex', justifyContent: 'space-between' }}>
										<div>Quantity Received: </div>
										<div>
											<div style={{ fontWeight: 'bold' }}>{product.qty} Unit(s)</div>
										</div>
									</div>
									{(product.shortInward === true && !product.freebie) ?
										<div style={{ display: 'flex', marginTop: '10px' }}>
											<div>Status: </div>
											<div style={{ color: '#BD2E23', marginLeft: '15px' }}>Short Inward</div>
										</div>
										:
										null
									}
									{(product.shortInward === false && !product.freebie) ?
										<div style={{ display: 'flex', marginTop: '10px' }}>
											<div>Status: </div>
											<div style={{ color: '#58a159', marginLeft: '15px' }}>All units received as per PO</div>
										</div>
										:
										null
									}

								</div>
								:
								null
							}
						</div>
					</div>
					{(product.shortInward === true && !product.freebie) ?
						<div style={{ marginTop: '10px', display: 'flex', justifyContent: 'center' }}>
							<button className="pdf-upload-label" style={{ padding: '6px' }} onClick={() => { this.onClickAddQty(receivedQuantity) }}>
								<img src={trolley} style={{ height: '20px', marginRight: '10px' }} alt="offer" />   Add more quantity
							</button>
						</div>
						:
						null
					}
				</div>
				{(product.manufacturerOffer) ?
					<div className="added-prdct-wrpr">
						<img src={offerIcon} alt="offer" /> {product.manufacturerOffer.title}
					</div> : null
				}

			</div>)
	}
}


// WEBPACK FOOTER //
// ./src/screens/Inwarding/Components/Commons/ListingProduct.js